import Vue from 'vue'
import Router from 'vue-router'
import pages from '@/pages/pagesData'

Vue.use(Router)

const routes = []
pages.forEach(item => {
  routes.push({
    path: item.link,
    name: item.pageName,
    component: require('@/pages/' + item.pageName).default
  })
})

let router = new Router({
  mode: 'history',
  routes: routes
})
router.beforeEach((to, from, next) => {
  // console.log("to, from", to, from);
  next()
})
// console.log("router", router);
export default router

// export default new Router({
//   mode: 'history',
//   routes: routes
// })




// WEBPACK FOOTER //
// ./src/router/index.js